import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type PrivateMedicalServiceActionBarProps = {
   readonly children: ReactNode;
};

export const PrivateMedicalServiceActionBar = (props: PrivateMedicalServiceActionBarProps): JSX.Element => {
   return (
      <ActionBar id={'private-medical-service-action-bar'} testId={'privateMedicalService'}>
         {props.children}
      </ActionBar>
   );
};
